import { useState } from "react";
import { Button, Form, Input, App } from "antd";
import { POST } from "../utils/apicalls";
import Logo from "../assets/logo.png";
import { API } from "../config/api";
import "../loginadmin/login.css";
interface RegisterClientProps {
  onSuccess: () => void; // onSuccess is a function with no parameters and no return value
}


const RegisterClient: React.FC<RegisterClientProps> = ({ onSuccess }) => {


  const [loading, setLoading] = useState(false);
  const { notification } = App.useApp();

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      const obj = {
        clientName: values.clientName,
        clientEmail: values.clientEmail,
        clientAddress: values.clientAddress,
        clientPhoneNumber: values.clientPhoneNumber,
        clientAltphone: values.clientAltphone,
        clientUsername: values.clientUsername,
        clientPassword: values.clientPassword,
        status: false,
        clientType: "client",
      };

      const url = API.REGISTER_CLIENT_DATA;
      const { data, message }: any = await POST(url, obj);

      if (data) {
        notification.success({ message });
        if (onSuccess) { // Call onSuccess properly
          onSuccess();
        }
      } else {
        notification.error({ message });
      }
    } catch (error) {
      console.error("Registration failed:", error);
      notification.error({ message: "Registration failed. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="loginScreen">
      <div className="backgroundOverlays"></div>
      <div className="loginContainers">
        <img src={Logo} alt="logo" className="loginLogo" />
        <div className="loginScreen-txt1">Register and Get Started</div>

        <Form onFinish={onFinish} layout="vertical" >
          <Form.Item
            label="Name"
            name="clientName"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Email"
            name="clientEmail"
            rules={[
              { required: true, message: "Required" },
              { type: "email", message: "Invalid email" },
            ]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Address"
            name="clientAddress"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Phone Number"
            name="clientPhoneNumber"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Alternate Phone"
            name="clientAltphone"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Username"
            name="clientUsername"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Password"
            name="clientPassword"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input.Password size="large" />
          </Form.Item>

          <Button
            block
            size="large"
            htmlType="submit"
            type="primary"
            loading={loading}
          >
            Register
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default RegisterClient;
